import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateEventSteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateEventSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Click the Create Event option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.EVENT}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 23 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="Enter the event details like the event title, event type, time and date, guest, description, and notification."
          type="create event"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.FORM}"]`,
      ],
      position: 'left',
      stepInteraction: false,
      styles: {
        popover: (base) => ({ ...base, marginRight: 10 }),
      },
    },
    {
      content: 'Click Save, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8 }),
      },
    },
  ];

  const showQuickCreateEventSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateEventSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateEventSteps;
};

export default useGetHowToQuickCreateEventSteps;
